// import React from "react";
import bg from "../../assets/images/10001.jpg";
import { FaLaptopHouse, FaRegListAlt, FaUsers } from "react-icons/fa";
import { GrAchievement } from "react-icons/gr";
function Achievements() {
  return (
    <div
      className="text-hiberet-primary bg-opacity-75 space-y-6 flex flex-col mt-7 h-full px-14 py-20 relative"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Black overlay for the image */}
      <div className="absolute inset-0 bg-black opacity-50 pointer-events-none"></div>
      <div>
        <h1 className="relative text-center md:text-6xl text-4xl font-bold text-white mb-6">
          See Our Achievements
        </h1>
      </div>

      <div className="relative flex-wrap flex justify-between space-y-4">
        <div className="flex items-center gap-3">
          <FaRegListAlt className="text-white font-bold text-7xl" />
          <div className="space-y-2">
            <h1 className="text-white font-bold text-5xl">499+</h1>
            <p className="text-white ">Total Listing</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <FaLaptopHouse className="text-white font-bold text-7xl" />
          <div className="space-y-2">
            <h1 className="text-white font-bold text-5xl">499+</h1>
            <p className="text-white ">Active Members</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <FaUsers className="text-white font-bold text-7xl" />
          <div className="space-y-2">
            <h1 className="text-white font-bold text-5xl">499+</h1>
            <p className="text-white ">Happy Users</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <GrAchievement className="text-white font-bold text-7xl" />
          <div className="space-y-2">
            <h1 className="text-white font-bold text-5xl">499+</h1>
            <p className="text-white ">Awards Winning</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Achievements;
